<div
  *ngIf="{ value: weatherInfo$ | async } as weatherInfo"
  class="fx-r-row fx-wrap w-full bg-white bg-opacity-60 px-3 fx-align-center">
  <div class="fx-col fx-b-0">
    <lib-weather-icon
      *ngIf="weatherInfo.value; else iconTemplate"
      class="s-25 mx-auto"
      [icon]="weatherInfo.value.weatherIcon">
    </lib-weather-icon>
  </div>
  <div class="fx-col fx-b-0 fx-g-1">
    <div class="body-3 overline text-grey-400 pr-3 py-3">
      <ng-container *ngIf="weatherInfo.value; else description">
        {{ weatherInfo.value.weather[0].description }}
      </ng-container>
      <ng-template #description>
        <ion-skeleton-text
          animated
          class="w-full">
        </ion-skeleton-text>
      </ng-template>
    </div>
    <div class="fx-row ml-3 mr-1 w-full">
      <div class="min-w-25 h2 text-grey-400">
        <ng-container *ngIf="weatherInfo.value; else temp">
          {{ weatherInfo.value.main.temp  | measures : 1 : '°C' }}
        </ng-container>
        <ng-template #temp>
          <ion-skeleton-text
            animated
            class="w-full">
          </ion-skeleton-text>
        </ng-template>
      </div>

      <div
        *ngIf="weatherInfo.value"
        class="border-r-1 border-grey-400">
      </div>

      <div class="fx-col text-grey-400 pl-3 w-full">
        <div class="body-2 py-3 fx-row fx-align-center w-full">
          <ng-container *ngIf="weatherInfo.value; else name">
            <ion-icon
              class="mr-1 s-4"
              name="location-outline">
            </ion-icon>
            <span>{{ weatherInfo.value.name }}</span>
          </ng-container>
          <ng-template #name>
            <ion-skeleton-text
              animated
              class="w-4p">
            </ion-skeleton-text>
          </ng-template>
        </div>
        <div class="body-3 w-full">
          <ng-container *ngIf="weatherInfo.value; else dt">
            {{ weatherInfo.value.dt * 1000 | date }}
          </ng-container>
          <ng-template #dt>
            <ion-skeleton-text
              animated
              class="w-4p">
            </ion-skeleton-text>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <ng-template #iconTemplate>
    <ion-skeleton-text
      animate
      class="s-20 p-5">
    </ion-skeleton-text>
  </ng-template>
</div>
